// Routing Constants
export const ACKNOWLEDGEMENT_PATH = "/acknowledgment";
export const EFILING_QUESTION_PATH = "/efiling_question";
export const EFILING_PATH = "/efiling";
export const INFORMAL_EFILING_PATH = "/informal_efiling";
export const ERECORDATION_PATH = "/erecordation";
export const RCPA_PATH = "/rcpa";
export const ENV_COMMENTS_PATH = "/environmental_comments";
export const ENHANCED_SEARCH_PATH = "/enhanced_search";
const RECENTS_PATH = "/recents";
export const CONFIRMATION_PATH = "/confirmation";
export const PAGE_NOT_FOUND_PATH = "/404";

export const RECENT_DECISIONS_PATH = `${RECENTS_PATH}/decisions`;
export const RECENT_FILINGS_PATH = `${RECENTS_PATH}/filings`;

// Search Routing Constants
export const DECISIONS_SEARCH_PATH = `${ENHANCED_SEARCH_PATH}/decisions`;
export const FILINGS_SEARCH_PATH = `${ENHANCED_SEARCH_PATH}/filings`;
export const RECORDATIONS_SEARCH_PATH = `${ENHANCED_SEARCH_PATH}/recordations`;
export const RAIL_RECORDATIONS_SEARCH_PATH = `${RECORDATIONS_SEARCH_PATH}/rail`;
export const WATER_RECORDATIONS_SEARCH_PATH = `${RECORDATIONS_SEARCH_PATH}/water`;
export const DOCKETS_SEARCH_PATH = `${ENHANCED_SEARCH_PATH}/dockets`;
export const ENV_COMMENTS_SEARCH_PATH = `${ENHANCED_SEARCH_PATH}/environmental_comments`;

// URL for PAY.GOV
export const PAY_GOV_URL = 'https://www.pay.gov/public/form/start/550880926';
export const PAY_GOV_LINK = "Pay.gov";
export const PAY_GOV_TITLE = "Link to Pay.gov";
export const FILING_FEE_URL = "https://www.stb.gov/stb/public/resources_fees.html";
export const FILING_FEE_LINK = "Filing Fee Description";
export const FILING_FEE_TITLE = "Link to Fees help";
